const flags = [
  { name: 'journey', isActive: false },
  { name: 'segments', isActive: false }
]

export default flags
